<template>
	<div class="add_distributors">
		<div class="import d-flex j-sb a-center">
			<el-upload
			    class="upload-demo box-upload"
			    drag
			    :limit="1"
			    action="http://www.spmall.com/seller/brand_center_pc_agent_api.php"
			    :data="{type:1,act:'import_data'}"
			    :on-success="onSuccess"
			    :before-upload="beforeUpload"
			    :on-remove="handleRemove"
			    :before-remove="beforeRemove"
				accept=".csv"
			    name="file"
				multiple>
			  <img src="../../assets/distributors/shangchuanexule@2x.png" alt="" style="width: 3.13rem;height: 3.13rem;">
			  <span>批量导入直营店/省分公司</span>
			  <img src="../../assets/distributors/yiwen@2x.png" alt="" style="width: 1rem;height: 1rem;position: absolute;right: 0.31rem;top: 0.31rem;">
			</el-upload>
			<el-upload
			  class="upload-demo box-upload"
			  drag
			  :limit="1"
			  action="http://www.spmall.com/seller/brand_center_pc_agent_api.php"
			  :data="{type:2,act:'import_data'}"
			  :on-success="onSuccess"
			  :before-upload="beforeUpload"
			  :on-remove="handleRemove"
			  :before-remove="beforeRemove"
			  accept=".csv"
			  name="file"
			  multiple>
			  <img src="../../assets/distributors/shangchuanexule@2x.png" alt="" style="width: 3.13rem;height: 3.13rem;">
			  <span>批量导入市分公司</span>
			  <img src="../../assets/distributors/yiwen@2x.png" alt="" style="width: 1rem;height: 1rem;position: absolute;right: 0.31rem;top: 0.31rem;">
			</el-upload>
			<el-upload
			  class="upload-demo box-upload"
			  drag
			  :limit="1"
			  action="http://www.spmall.com/seller/brand_center_pc_agent_api.php"
			  :data="{type:3,act:'import_data'}"
			  :on-success="onSuccess"
			  :before-upload="beforeUpload"
			  :on-remove="handleRemove"
			  :before-remove="beforeRemove"
			  accept=".csv"
			  name="file"
			  multiple>
			  <img src="../../assets/distributors/shangchuanexule@2x.png" alt="" style="width: 3.13rem;height: 3.13rem;">
			  <span>批量导入加盟店</span>
			  <img src="../../assets/distributors/yiwen@2x.png" alt="" style="width: 1rem;height: 1rem;position: absolute;right: 0.31rem;top: 0.31rem;">
			</el-upload>
			<div class="box d-flex flex-column j-se a-center position-relative">
				<div class=" box1 d-flex j-center a-center" @click="openURL('http://www.spmall.com/data/agent_import_template/province_template.csv');">
					<img src="../../assets/distributors/dangexiazai@2x.png" alt="" style="width: 0.88rem;height: 0.88rem;margin-right: 0.38rem;">
					<span>下载“省分公司”批量导入模板</span>
				</div>
				<div class=" box1 d-flex j-center a-center" @click="openURL('http://www.spmall.com/data/agent_import_template/city_template.csv');">
					<img src="../../assets/distributors/dangexiazai@2x.png" alt="" style="width: 0.88rem;height: 0.88rem;margin-right: 0.38rem;">
					<span>下载“市分公司”批量导入模板</span>
				</div>
				<div class=" box1 d-flex j-center a-center" @click="openURL('http://www.spmall.com/data/agent_import_template/franchise_template.csv');">
					<img src="../../assets/distributors/dangexiazai@2x.png" alt="" style="width: 0.88rem;height: 0.88rem;margin-right: 0.38rem;">
					<span>下载“加盟门店”批量导入模板</span>
				</div>
				<el-button class="box1" round style="width: 5.75rem;height: 1.5rem;background: #1E69FF;color: #FFFFFF;padding: 0;font-size: 0.75rem;"
				 @click="openURL('http://www.spmall.com/data/agent_import_template/import_template.zip');">全部下载</el-button>
				<img src="../../assets/distributors/yiwen@2x.png" alt="" style="width: 1rem;height: 1rem;position: absolute;right: 0.31rem;top: 0.31rem;">
			</div>
		</div>
		<div v-if="state == true">
			<div style="margin-top: 2.63rem;display: flex;align-items: center;">
				<span style="display: block;font-weight: bold;">单个添加</span>
				<span style="color: red;">(注意带*的为必填项)</span>
			</div>
			
			<div class="table">
				<div class="name d-flex flex-column j-sb a-center">
					<div class="w-100 d-flex j-sb a-center disLevel">
						<div>
							<span>分销商级别：</span>
							<span style="color: red;">*</span>
						</div>
						<el-select @change="selectDis" v-model="message.rank_name" value-key="rank_name" placeholder="请选择分销商级别" >
							<el-option  v-for="(item,index) in options" :value="item" :label="item.rank_name">
							</el-option>
						</el-select>
					</div>
					<div class="w-100 d-flex j-sb a-center">
						<div>
							<span>分销商名称：</span>
							<span style="color: red;">*</span>
						</div>
						<input type="text" v-model="message.agent_name" placeholder="请输入分销商名称" style="width: 14.06rem;height: 1.69rem;box-sizing: border-box;outline: none;border: 2px solid #BBBBBB;border-radius: 4px;">
					</div>
					<!-- <div class="w-100 d-flex j-sb a-center">
						<span>所属上级：</span>
						<input disabled="true" type="text" placeholder="分销商名称" style="width: 14.06rem;height: 1.69rem;box-sizing: border-box;outline: none;border: 2px solid #BBBBBB;border-radius: 4px;color: #BBBBBB;">
					</div> -->
					<div class="w-100 d-flex j-sb a-center disLevel">
						<div>
							<span>所属上级：</span>
							<span style="color: red;">*</span>
						</div>
						<el-select @change="selectParentDis" v-model="message.up_agent_name" placeholder="请选择所属上级" >
							<el-option :value="item.up_agent_id" :label="item.up_agent_name" v-for="(item,index) in parentDis" :key="index">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="location d-flex flex-column j-sb a-center">
					<div class="top flex-1 w-100 d-flex flex-column j-sa a-center">
						<div class="top flex-1 w-100 d-flex flex-column j-sa a-center">
							<div class="w-100 d-flex j-sb a-center">
								<div>
									<span>所在地区：</span>
									<span style="color: red;">*</span>
								</div>					
								<div class="d-flex j-sb a-center" style="width: 27.66rem;">
									<select name="" id="" disabled
										style="width: 6.09rem;height: 1.69rem;padding: 0 0.22rem;outline: none;border: 2px solid #BBBBBB;border-radius: 4rpx;color: #BBBBBB;">
										<option :value="item.label" :label="item.value" v-for="(item,index) in contry"
											:key="index"></option>
									</select>
									<el-select name="" id="" @change="changeProvince" v-model="message.province" value-key="region_id"
										placeholder="请选择所在省份">
										<el-option :value="item" :label="item.region_name"
											v-for="(item,index) in provinceList" :key="index"></el-option>
									</el-select>
									<el-select name="" id="" @change="changeCity" v-model="message.city" placeholder="请选择所在市区" value-key="region_id">
										<el-option :value="item" :label="item.region_name"
											v-for="(item,index) in cityList" :key="index"></el-option>
									</el-select>
									<el-select name="" id="" @change="changeArea" v-model="message.district"
										placeholder="请选择所在县" value-key="region_id">
										<el-option :value="item" :label="item.region_name"
											v-for="(item,index) in areaList" :key="index"></el-option>
									</el-select>
								</div>
							</div>
							<div class="w-100 d-flex j-sb a-center">
								<div>
									<span>详细地址：</span>
									<span style="color: red;">*</span>
								</div>
								<input type="text" v-model="message.stores_address" placeholder="请输入详细地址"
									style="width: 27.66rem;height: 1.69rem;box-sizing: border-box;outline: none;border: 2px solid #BBBBBB;border-radius: 4px;">
							</div>
						</div>
					</div>
					<div class="bottom flex-1 w-100 d-flex j-sb a-center">
							<div class="left h-100 d-flex flex-column j-sa a-center">
								<div class="w-100 d-flex j-sb a-center">
									<div>
										<span>经度(Y)：</span>
										<span style="color: red;">*</span>
									</div>
								</div>
								<div class="w-100 d-flex j-sb a-center">
									<div>
										<span>纬度(X)：</span>
										<span style="color: red;">*</span>
									</div>
								</div>
							</div>
							<div class="right h-100 d-flex j-sb a-center" style="width: 27.66rem;">
								<div class="h-100 d-flex j-sa flex-column a-center">
									<div class="w-100 d-flex j-sb a-center">
										<input type="text" v-model="message.lng" placeholder="点击获取经纬度"
											style="width: 14.06rem;height: 1.69rem;box-sizing: border-box;outline: none;border: 2px solid #BBBBBB;border-radius: 4px;">
									</div>
									<div class="w-100 d-flex j-sb a-center">
										<input type="text" v-model="message.lat" placeholder="点击获取经纬度"
											style="width: 14.06rem;height: 1.69rem;box-sizing: border-box;outline: none;border: 2px solid #BBBBBB;border-radius: 4px;">
									</div>
								</div>
								<div class="h-100 position-relative"  @click="mapClick(message.lng,message.lat)"
									style="width: 12.69rem;height: 5.69rem;background: #EEF4FF;border-radius: 6px;">
									<div class="get_location">获取经纬度</div>
								</div>
							</div>
						</div>
					</div>
					<div class="account d-flex flex-column j-sb a-center">
						<div class="w-100 d-flex j-sb a-center">
							<div>
								<span>登陆名称：</span>
								<span style="color: red;">*</span>
							</div>
							<input type="text" v-model="message.user_name" placeholder="请输入登陆名称"
								style="width: 14.06rem;height: 1.69rem;box-sizing: border-box;outline: none;border: 2px solid #BBBBBB;border-radius: 4px;">
						</div>
						<div class="w-100 d-flex j-sb a-center">
							<div>
								<span>登陆密码：</span>
								<span style="color: red;">*</span>
							</div>
							<input type="text" v-model="password" placeholder="请输入登陆密码"
								style="width: 14.06rem;height: 1.69rem;box-sizing: border-box;outline: none;border: 2px solid #BBBBBB;border-radius: 4px;">
						</div>
					</div>
					<div class="person_in_charge d-flex flex-column j-sb a-center">
						<div class="w-100 d-flex j-sb a-center">
							<div>
								<span>负责人：</span>
								<span style="color: red;">*</span>
							</div>
							<input type="text" v-model="message.seller_name" placeholder="请输入负责人姓名"
								style="width: 14.06rem;height: 1.69rem;box-sizing: border-box;outline: none;border: 2px solid #BBBBBB;border-radius: 4px;">
						</div>
						<div class="w-100 d-flex j-sb a-center">
							<div>
								<span>联系方式：</span>
								<span style="color: red;">*</span>
							</div>
							<input type="text" v-model="message.stores_tel" placeholder="请输入联系方式"
								style="width: 14.06rem;height: 1.69rem;box-sizing: border-box;outline: none;border: 2px solid #BBBBBB;border-radius: 4px;">
						</div>
						<div class="w-100 d-flex j-sb a-center">
							<span>Email：</span>
							<input type="text" v-model="message.email" placeholder="请输入邮箱"
								style="width: 14.06rem;height: 1.69rem;box-sizing: border-box;outline: none;border: 2px solid #BBBBBB;border-radius: 4px;">
						</div>
					</div>
					<div class="logo d-flex flex-column j-sb a-start">
						<!-- <span>录入时间：{{message.add_time | timeStamp}}</span> -->
						<div class="w-100 flex-1 d-flex j-sb a-center" style="margin-top: 2.38rem;">
							<div class="h-100 d-flex flex-column j-sb a-start">
								<span>门店logo:</span>
								<el-upload
								  class="avatar-uploader"
								  action="upload"
								  :show-file-list="false"
								  :on-change="getFile"
								  :http-request="handleUploadFile"
								  :on-success="handleAvatarSuccess"
								  :before-upload="beforeAvatarUpload"
								  accept=".jpg,.png"
								  >
								  <img v-if="message.stores_logo" :src="message.stores_logo" class="avatar">
								  <!-- <img :src="message.stores_logo" alt="" style="width: 9.38rem;height: 9.38rem;"> -->
								  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
							</div>
							<div class="h-100 d-flex flex-column j-sb a-start">
								<span>实景图片:</span>
								<el-upload
								  class="avatar-uploader avatar-liveimg"
								  action="upload"
								  :show-file-list="false"
								  :on-change="getLiveFile"
								  :http-request="handleUploadFile"
								  :on-success="handleAvatarSuccess"
								  :before-upload="beforeAvatarUpload"
								  >
								  <img v-if="message.live_img" :src="message.live_img" class="avatar-liveimg">
								  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
							</div>
						</div>
					</div>
			</div>
			<footer class="d-flex j-center a-center">
				<div class="d-flex j-center a-center">
					<span>是否开启：</span>
					<el-switch v-model="message.is_confirm" @change="switchChange(message.is_confirm)" active-value="1" inactive-value="0" active-color="#1E69FF" inactive-color="#B5CBF9">
					</el-switch>
				</div>
				<div style="margin-left: 6.63rem;width: 7.09rem;height: 1.69rem;
				background: #1E69FF;color: #FFFFFF;text-align: center; line-height: 1.69rem;border-radius: 0.845rem;cursor: pointer;"  @click="releaseDistributor">发布</div>
			</footer>
		</div>
		<div class="company-table" v-else>
			<span style="margin-top: 2.63rem;display: block;font-weight: bold;">导入直营店/分公司列表成功</span>
			<div class="table-upload">
				<el-table ref="multipleTable" :border="false" :data="tableData" tooltip-effect="dark"
					style="font-size: 0.75rem;" @selection-change="handleSelectionChange">
					<el-table-column align="center" type="selection" label="">
					</el-table-column>
					<el-table-column align="center" prop="agent_name" label="省分公/直营店司名称" show-overflow-tooltip>
					</el-table-column>
					<el-table-column align="center" prop="rank_name" label="类型" show-overflow-tooltip>
					</el-table-column>
					<el-table-column align="center" prop="address || adress" label="详细地址" show-overflow-tooltip>
					</el-table-column>
					<el-table-column align="center" prop="seller_name" label="负责人" show-overflow-tooltip>
					</el-table-column>
					<el-table-column align="center" prop="mobile" label="联系电话" show-overflow-tooltip>
					</el-table-column>
					<el-table-column align="center" prop="up_agent_name" label="所属上级" show-overflow-tooltip>
					</el-table-column>
					<el-table-column align="center" prop="time" label="录入时间" width="150" show-overflow-tooltip>
					</el-table-column>
				</el-table>
			</div>
			<footer class="d-flex j-sb a-center">
				<div>
					<el-button round size="mini" @click="sendFranchisee">一件发送至加盟商</el-button>
					<el-button round size="mini" @click="delAgentConfirm">删除</el-button>
				</div>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-size="10" layout="prev, pager, next, total" :total="total_records">
				</el-pagination>
			</footer>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				contry : [{
					value: '中国',
					label: 'CN'
				},],
				provinceList: [], // 省份列表
				cityList: [], // 城市列表
				areaList: [], // 区/县列表
				options: [],
				parentDis : [],
				is_open: true,
				state:true,
				currentPage: 1, //初始页
				pageSize: 10, //    每页的数据
				tableData: [],
				multipleSelection: [],
				agentId : [],
				total_records : 0,
				message : {
					add_time: "",
					agent_name: "",
					city: "",
					city_id: "",
					district: "",
					district_id: "",
					email: "",
					is_confirm: "1",
					lat: "",
					live_img: "",
					lng: "",
					province: "",
					province_id: "",
					rank_id: "",
					rank_name: "",
					seller_name: "",
					shop_info_status: "0",
					stores_address: "",
					stores_logo: "",
					stores_tel: "",
					up_agent_id: "",
					up_agent_name: "",
					user_name: ""
				},
				password : '',
				strimagebase64 : '',
				liveimgbase64 : '',
				address : ''
			}
		},
		methods:{
			getProviceData(){
				this.$api.getProvince().then((res) => {
					this.provinceList = res.data
				})
			},
			getCity(cityId){
				let param = {
					province_id : cityId
				}
				this.$api.getCity(param).then((res) => {
					this.cityList = res.data
				})
			},
			getArea(areaId){
				let param = {
					city_id : areaId
				}
				this.$api.getArea(param).then((res) => {
					this.areaList = res.data
				})
			},
			changeProvince(e) {
				this.message.province = e.region_name
				this.message.province_id = e.region_id
				let param = {
					province_id : e.region_id
				}
				this.$api.getCity(param).then((res) => {
					this.cityList = res.data
					this.message.city = this.cityList[0].region_name
					this.message.city_id = this.cityList[0].region_id
					let id = this.cityList[0].region_id
					let param = {
						city_id : id
					}
					this.$api.getArea(param).then((res) => {
						this.areaList = res.data
						this.message.district = this.areaList[0].region_name
						this.message.district_id = this.areaList[0].region_id
					})
				})
			},
			changeCity(e) {
				this.message.city_id = e.region_id
				this.message.city = e.region_name
				let param = {
					city_id : e.region_id
				}
				this.$api.getArea(param).then((res) => {
					this.areaList = res.data
					this.message.district = this.areaList[0].region_name
					this.message.district_id = this.areaList[0].region_id
				})
			},
			changeArea(e) {
				this.message.district = e.region_name
				this.message.district_id = e.region_id
			},
			mapClick(lng, lat) {
				if(this.message.province == '' || this.message.city == '' ||this.message.district == '' ||this.message.stores_address == '' ){
					this.$message.warning('请完整填写地址！')
				}else {
					this.address = this.message.province + '省' + this.message.city + '市' + this.message.district + this.message.stores_address
					this.$axios.get('https://restapi.amap.com/v3/geocode/geo?address=' + this.address + "&key=" + '230940c14da34b25391f85531b3c4067'+ "&output=" + 'JSON').then((res) => {
						let map = res.data.geocodes[0].location
						let arrmap = map.split(',')
						this.message.lng = arrmap[0]
						this.message.lat = arrmap[1]
						// 地图逆推理
						// this.$axios.get('https://restapi.amap.com/v3/geocode/regeo?location=' + map + "&key=" + '230940c14da34b25391f85531b3c4067').then(res => {
						// 	console.log(res);
						// })
					})
				}
				// 定义点标记对象
				// this.$nextTick(() => {
				// 	this.initMap(lng, lat)
				// })
			},
			getDistributors(){
				let param = {
					act : 'agent_rank'
				}
				this.$api.company_list(param).then((res)=>{
					this.options = res.data
				})
			},
			selectDis(e){
				this.message.rank_id = e.rank_id
				let param = {
					act : 'rank_superior',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					rank_level : e.rank_id
				}
				this.$api.company_list(param).then((res)=>{
					if(res.code == 0){
						if(res.data.up_agent_id == 0){
							this.$message.warning('暂无所属上级')
						}else {
							this.parentDis = res.data
						}
					}else {
						this.$message.error('选择分销商级别失败')
					}
				})
			},
			selectParentDis(e){
				this.message.up_agent_id = e
			},
			// 获取图片转base64
			getBase64(file) {
			  return new Promise(function(resolve, reject) {
				const reader = new FileReader()
				let imgResult = ''
				reader.readAsDataURL(file)
				reader.onload = function() {
				  imgResult = reader.result
				}
				reader.onerror = function(error) {
				  reject(error)
				}
				reader.onloadend = function() {
				  resolve(imgResult)
				}
			  })
			},
			// 图片转base64    
			getFile(file, fileList) {
			    this.getBase64(file.raw).then(res => {
					let params = res.split(',')
			        if (params.length > 0) {
						this.strimagebase64 = res
						// this.handleUploadFile()
						let param = {
							act : 'public_upload_file',
							file : this.strimagebase64
						}
						this.$api.uploadPicture(param).then((res) => {
							if(res.code == 0){
								this.message.stores_logo = res.data
								this.$message.success('图片上传成功');
							}else {
								this.$message.error('图片上传失败');
							}
						}).catch(response => {
							this.$message.error('图片上传失败');
						})
			        }
			    })
			},
			getLiveFile(file, fileList) {
			    this.getBase64(file.raw).then(res => {
			        let params = res.split(',')
			        if (params.length > 0) {
			          this.liveimgbase64 = res
					  // this.handleUploadFile()
					  let param = {
						act : 'public_upload_file',
					  	file : this.liveimgbase64
					  }
					  this.$api.uploadPicture(param).then((res) => {
					  	if(res.code == 0){
							this.message.live_img = res.data
					  		this.$message.success('图片上传成功');
					  	}else {
					  		this.$message.error('图片上传失败');
					  	}
					  }).catch(response => {
							this.$message.error('图片上传失败');
					  })
			        }
			    })
			},
			handleUploadFile(){
				
			},
			beforeAvatarUpload(file) {
				// const isJPG = file.type === 'image/jpeg';
				// const isLt2M = file.size / 1024 / 1024 < 2;
					
				// if (!isJPG) {
				//   this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				// if (!isLt2M) {
				//   this.$message.error('上传头像图片大小不能超过 2MB!');
				// }
				// return isJPG && isLt2M;
			},
			handleAvatarSuccess(res, file) {
				this.message.stores_logo = URL.createObjectURL(file.raw);
			},
			switchChange(confirmStatus){
				this.message.is_confirm = confirmStatus
			},
			beforeUpload(file) {
			     let testmsg=file.name.substring(file.name.lastIndexOf('.')+1)
			     let extension = testmsg === 'csv'
			     // const isLt2M = file.size / 1024 / 1024 < 10
			     if(!extension) {
			         this.$message({
			             message: '上传文件只能是csv格式!',
			             type: 'warning'
			         });
			     }
			     // 也可以在这里增加文件大小限制
			     // if(!isLt2M) {
			     //     this.$message({
			     //         message: '上传文件大小不能超过 10MB!',
			     //         type: 'warning'
			     //     });
			     // }
			     // return (extension || extension2) && isLt2M
			     return extension
			},
			handleRemove(){},
			beforeRemove(file, fileList) {
				return this.$msgbox.confirm(`确定移除 ${ file.name }？`);
			},
			onSuccess(response, file, fileList) {
				if(response.code == 0){
					this.state = false
					this.tableData = this.tableData.concat(response.data)
					this.total_records = this.tableData.length
					this.$message.success('上传模板成功');
				}else {
					this.$message.error(res.msg);
				}
			},
			openURL(src){
				let $a = document.createElement('a');
				$a.setAttribute('href', src);
				$a.setAttribute('download', '省分公司模板');
				let fileLink = document.createElement('span');
				fileLink.setAttribute('style', 'cursor: pointer; -webkit-tap-highlight-color: transparent');
				$a.appendChild(fileLink);
				let body = document.getElementsByTagName('body')[0];
				body.appendChild($a);
				fileLink.click();
				body.removeChild($a);
			},
			handleSelectionChange(val) {
				this.multipleSelection = val
			},
			// 发送至加盟商
			sendFranchisee(){
				if(this.multipleSelection.length == 0){
					this.$message.warning('未选择任何公司或直营店！')
				}else{
					let param = {
						act : 'batch_add',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						data : JSON.stringify(this.multipleSelection)
					}
					this.$api.company_list(param).then((res) => {
						console.log(res);
						if(res.code == 0){
							this.$message.success('发送至加盟商成功！');							
						}else{
							this.$message.error('发送至加盟商失败！');
						}
					}).catch((err) => {
						this.$message.error(err);
					})
				}
			},
			// 批量删除
			delAgentConfirm(){
				if(this.multipleSelection.length == 0){
					this.$message({
						type: 'warning',
						message: '请至少选择一个公司！'
					});
				}else{
					this.$msgbox.confirm('是否确认此操作?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						let that = this
						let val = this.multipleSelection
						if (val) {
							val.forEach(function(item, index) {
								that.tableData.forEach(function(itemI, indexI) {
									if (item === itemI) {
										that.tableData.splice(indexI, 1);
									}
								});
							});
							this.total_records = that.tableData.length
							this.$refs.multipleTable.clearSelection();
						}
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});  
					})					
				}
			},
			handleSizeChange(size) {
				this.pageSize = size;
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
			},
			releaseDistributor(){
				let param = {
					act : 'operation_agent',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id : this.agent_id,
					ctrl : 'add',
					rank_id : this.message.rank_id,
					agent_name : this.message.agent_name,
					up_agent_id : this.message.up_agent_id,
					username : this.message.user_name,
					password : this.password,
					seller_name : this.message.seller_name,
					stores_tel : this.message.stores_tel,
					email : this.message.email,
					province : this.message.province_id,
					city : this.message.city_id,
					district : this.message.district_id,
					stores_address : this.message.stores_address,
					lng : this.message.lng,
					lat : this.message.lat,
					stores_logo : this.strimagebase64,
					live_img : this.liveimgbase64,
					is_confirm : this.message.is_confirm,
				}
				const loading = this.$loading({
					lock: true,
					text: '发布中',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				this.$api.editDistributors(param).then((res) => {
					loading.close()
					// 单独发布返回报sql错误
					if(res.code == 0){
						this.$message.success('编辑发布成功');
					}else{
						this.$message.error('编辑发布失败');
					}
				}).catch(err => {
					this.$message.error('编辑发布失败');
				})
			},
		},
		mounted() {
			this.getProviceData()
			this.getDistributors()
		}
	}
</script>
<style>
	/* .el-input,.el-input--suffix{
		height: 1.69rem;
	}
	.el-input__inner{
		height: 1.69rem;
	} */
	/* @import url("//unpkg.com/element-ui@2.15.1/lib/theme-chalk/index.css"); */
	.box-upload{
		width: 16.88rem;
		height: 8.44rem;
		border: 2px solid #1E69FF;
		border-radius: 4px;
		font-size: 0.75rem;
		color: #1E69FF;
		font-weight: bold;
		cursor: pointer;
	}
	.box-upload :hover{
		background: #caddff;
	}
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 9.38rem;
	    height: 9.38rem;
	    line-height: 9.38rem;
	    text-align: center;
	  }
	  .avatar-liveimg .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 17.875rem;
	    height: 9.38rem;
	    line-height: 9.38rem;
	    text-align: center;
	  }
	.avatar {
	  width: 9.38rem;
	  height: 9.38rem;
	  display: block;
	}
	.avatar-liveimg {
	  width: 17.875rem;
	  height: 9.38rem;
	  display: block;
	}
	
</style>
<style lang="scss" scoped>
	@mixin common {
		background: #FFFFFF;
		border-radius: 6px;
		padding: 1.1rem 0.94rem;
		box-sizing: border-box;
	}
	/deep/ .box-upload .el-upload-dragger{
		width: 16.88rem !important;
		height: 8.44rem !important;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	/deep/ .el-input {
		width: 7.09rem;
		height: 1.69rem;
		border: 2px solid #BBBBBB;
		color: #BBBBBB;
		box-sizing: border-box;
	}
	/deep/ .el-select .el-input__inner{
		border: 0;
		width: 100%;
		height: 100%;
	}
	/deep/ .el-input__suffix{
		display: flex;
		align-items: center;
	}
	/deep/ .disLevel .el-input{
		width: 14.06rem;
	}
	input {
		padding: 0 0.44rem;
		&::-webkit-input-placeholder {
			/* WebKit, Blink, Edge */
			color: #BBBBBB;
			font-size: 0.75rem;
		}

		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: #BBBBBB;
			font-size: 0.75rem;
		}

		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: #BBBBBB;
			font-size: 0.75rem;
		}

		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: #BBBBBB;
			font-size: 0.75rem;
		}
	}
	.company-table{
		.table-upload {
			margin-top: 1.44rem;
			width: 100%;
			background: #FFFFFF;
			border-radius: 6px;
			overflow: hidden;
		}
	}
	.add_distributors {
		max-width: 73.13rem;
		box-sizing: border-box;
		margin: 0 auto;
		padding: 0 0 3.63rem 0;

		.box {
			width: 16.88rem;
			height: 8.44rem;
			border: 2px solid #1E69FF;
			border-radius: 4px;
			font-size: 0.75rem;
			color: #1E69FF;
			font-weight: bold;
			cursor: pointer;
			.box1:hover{
				color: red !important;
				text-decoration: underline;
			}
		}

		.table {
			display: grid;
			grid-template-rows: 12.5rem 3.75rem 4.69rem 12.5rem;
			grid-template-columns: 30.01rem 42.2rem;
			gap: 0.94rem;
			font-size: 0.75rem;
			font-weight: bold;
			margin-top: 1rem;

			.name {
				@include common;
				grid-row: 1/2;
				grid-column: 1/2;
				padding: 1.88rem 2.25rem;
			}

			.location {
				@include common;
				grid-row: 1/3;
				grid-column: 2/3;
				padding: 1.88rem 2.25rem;

				.get_location {
					font-size: 0.75rem;
					color: #1E69FF;
					background: #FFFFFF;
					width: 5.59rem;
					height: 1.41rem;
					text-align: center;
					line-height: 1.41rem;
					border-radius: 0.705rem;
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);
					box-shadow: 0px 7px 7px 0px rgba(30, 105, 255, 0.4);
					cursor: pointer;

					&::after {
						content: '';
						border: 5px solid transparent;
						border-top-color: #FFFFFF;
						position: absolute;
						bottom: 0;
						left: 50%;
						transform: translate(-50%, 100%);
					}
				}
			}

			.account {
				@include common;
				grid-row: 2/4;
				grid-column: 1/2;
				padding: 1.88rem 2.25rem;
			}

			.person_in_charge {
				@include common;
				grid-row: 4/5;
				grid-column: 1/2;
				padding: 1.88rem 2.25rem;
			}

			.logo {
				@include common;
				grid-row: 3/5;
				grid-column: 2/3;
				padding: 1.88rem 2.25rem;
			}
		}

		footer {
			@include common;
			padding: 0 1.88rem;
			width: 100%;
			height: 3.28rem;
			margin-top: 1.31rem;
			font-size: 0.75rem;
		}
	}
</style>
